export function ClipboardFindNewObj(childPairs, objID) {
  var n = childPairs.length;
  for (var i = 0; i < n; i++) {
    var aChild = childPairs[i];
    var newObj = aChild["newobj"];
    if (aChild["objID"] == objID && newObj != null) return newObj;
  }

  console.log("Fail:ClipboardFindNewObj"); // Should never happen
  return null;
}
